import React from "react";

const ClientOrdersModule = React.lazy(() => import("./ui/Orders"));

export const ClientOrdersPage = () => {
  return <ClientOrdersModule />;
};
